export default "__VITE_ASSET__CzBDqhR___"